<template>
  <div
    class="z-max absolute"
    v-if="allowedNoty"
    :class="{'inset-x-0 bottom-0': isDesktop, 'inset-x-4 top-2 h-19': isMobile, 'pointer-events-none': notyQueue.length === 0}"
  >
    <TransitionGroup name="notifications" class="flex flex-col gap-2" :class="{'pb-12': isDesktop}">
      <div
        v-for="noty in notyQueue"
        :key="noty.id"
        :ref="`noty_${noty.id}`"
        @click="goToMessage(noty)"
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchEnd"
        @touchcancel="onTouchEnd"
        @mousedown="onMouseDown"
        @mousemove="onMouseMove"
        @mouseup="onMouseUp"
        class="flex items-start gap-2 p-2 bg-white rounded-md cursor-pointer"
        :class="{'relative': isDesktop, 'absolute inset-x-0': isMobile}"
        style="box-shadow: 0px 5px 10px rgba(31, 31, 31, 0.12)"
        :style="isMobile ? {top: `-${top}px`} : {}"
      >
        <img :src="noty.image" class="w-8 h-8 rounded-full" />
        <div class="flex flex-col">
          <t-text class="font-semibold" v-if="noty.chat_type === 'chat'" color="black">{{ noty.sender.fullname }}</t-text>
          <t-text class="font-semibold" v-else color="black">{{ noty.title }}</t-text>
          <t-text class="line-clamp-2 break-word" v-if="noty.chat_type === 'chat'" color="black">{{ noty.description }}</t-text>
          <t-text class="line-clamp-2 break-word" v-else color="black">
            <t-text class="font-semibold" color="black">{{ noty.sender.fullname }}:</t-text>
            {{ noty.description }}
          </t-text>
        </div>
        <ph-x @click.stop="clearNoty(noty)" v-if="isDesktop" :size="22" class="top-2 right-2 absolute text-black cursor-pointer" />
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import handleViewport from '@/utils/mixins/handleViewport'
  export default {
    name: 'AppNotifications',
    data() {
      return {
        notyQueue: [],
        startY: 0,
        currentY: 0,
        dragging: false,
        top: 0
      }
    },
    mixins: [handleViewport],
    computed: {
      ...mapGetters('user', ['userMenu', 'userNotifications']),
      allowedNoty() {
        return this.userNotifications && this.userNotifications.inapp && this.userNotifications.inapp.enabled
          ? +this.$route.params.app_module_id !== +this.chatModuleId
          : false
      },
      chatModuleId() {
        return this.userMenu.find(el => el.type === 'chats') ? this.userMenu.find(el => el.type === 'chats').app_module_id : null
      }
    },
    methods: {
      goToMessage(noty) {
        const chatModule = this.userMenu.find(el => el.type === 'chats')
        this.$router.push({
          name: 'chats.item',
          params: {
            app_module_id: chatModule.app_module_id,
            chat_type: noty.chat_type,
            id: noty.chat_id
          }
        })
      },
      clearNoty(noty) {
        if (noty) {
          const idx = this.notyQueue.indexOf(noty)
          this.notyQueue.splice(idx, 1)
        }
      },
      onTouchStart(event) {
        this.startY = event.touches[0].clientY
        this.currentY = this.startY
        this.dragging = true
      },
      onTouchMove(event) {
        if (!this.dragging) return
        this.currentY = event.touches[0].clientY
        this.calculateTop()
      },
      onTouchEnd() {
        this.dragging = false
        this.resetNotification()
      },
      onMouseDown(event) {
        this.startY = event.clientY
        this.currentY = this.startY
        this.dragging = true
      },
      onMouseMove(event) {
        if (!this.dragging) return
        this.currentY = event.clientY
        this.calculateTop()
      },
      onMouseUp() {
        this.dragging = false
        this.resetNotification()
      },
      calculateTop() {
        const deltaY = this.startY - this.currentY
        if (deltaY > 0) {
          this.top = deltaY
        }
      },
      resetNotification() {
        if (this.top > 20) {
          this.clearNoty(this.notyQueue[0])
        } else {
          // Не смахнули уведомление вверх, сброс
          this.top = 0
        }
      }
    },
    sockets: {
      chatMessage(data) {
        if (data.chat.id === this.$route.params.id) return
        if (this.isDesktop) {
          if (this.notyQueue.length >= 3) return
          this.top = 0
          this.notyQueue.push({
            id: data.id,
            chat_id: data.chat.id,
            chat_type: data.chat.is_group ? 'group' : 'chat',
            image: data.chat.is_group ? data.chat.logo : data.sender.avatar,
            title: data.chat.chat_name,
            sender: data.sender,
            description: data.message ? data.message : this.$t('components.inAppPush.attachment')
          })
          setTimeout(() => {
            const noty = this.notyQueue.find(el => el.id === data.id)
            if (noty) {
              const idx = this.notyQueue.indexOf(noty)
              this.notyQueue.splice(idx, 1)
            }
          }, 20000)
        } else if (this.isMobile) {
          if (this.notyQueue.length !== 0) {
            setTimeout(() => {
              const noty = this.notyQueue[0]
              if (noty) {
                const idx = this.notyQueue.indexOf(noty)
                this.notyQueue.splice(idx, 1)
              }
            }, 100)
          }
          this.top = 0
          this.notyQueue.push({
            id: data.id,
            chat_id: data.chat.id,
            chat_type: data.chat.is_group ? 'group' : 'chat',
            image: data.chat.is_group ? data.chat.logo : data.sender.avatar,
            title: data.chat.chat_name,
            sender: data.sender,
            description: data.message ? data.message : this.$t('components.inAppPush.attachment')
          })
          setTimeout(() => {
            const noty = this.notyQueue.find(el => el.id === data.id)
            if (noty) {
              const idx = this.notyQueue.indexOf(noty)
              this.notyQueue.splice(idx, 1)
            }
          }, 20000)
        }
      }
    }
  }
</script>

<style scoped>
  .notifications-move,
  .notifications-enter-active,
  .notifications-leave-active {
    transition: all 0.3s ease;
  }
  .notifications-enter-from {
    opacity: 0;
    transform: translateY(200px);
  }

  .notifications-leave-to {
    opacity: 0;
  }
</style>
